import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

type LayoutModalBodyProps = {
  viewportHeight: number
}

export const LayoutModalAppBar = styled(AppBar)(() => ({
  position: 'relative',
  background:
    'linear-gradient(180deg, rgba(15, 18, 23, 0.98) 0%, rgba(10, 13, 18, 1) 100%)',
}))

export const LayoutModalToolbar = styled(Toolbar)(() => ({
  justifyContent: 'space-between',
}))

export const LayoutModalTitle = styled(Typography)(() => ({
  color: '#f6fbff',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
}))

export const LayoutModalBody = styled('div', {
  shouldForwardProp: (prop) => prop !== 'viewportHeight',
})<LayoutModalBodyProps>(({ theme, viewportHeight }) => ({
  height: viewportHeight - 8,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1),
  background:
    'linear-gradient(180deg, rgba(14, 19, 25, 1) 0%, rgba(9, 13, 19, 1) 100%)',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(2),
  },
}))

export const LayoutModalInner = styled('div')(() => ({
  width: '100%',
  height: '100%',
  maxWidth: 1500,
  margin: '0 auto',
}))
